import NotFound from "@/components/common/pages/not-found";
import type { AuthContextType } from "@/providers/auth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  HeadContent,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import * as React from "react";
import { PhotoProvider } from "react-photo-view";
import { Toaster } from "sonner";

interface MyRouterContext {
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
  head: () => ({
    meta: [
      {
        name: "description",
        content: "OpenFarming is a web application for distributors",
      },
      {
        title: "OpenFarming",
      },
    ],
    links: [
      {
        rel: "icon",
        href: "/favicon.ico",
      },
    ],
    scripts: [
      {
        src: "https://www.google-analytics.com/analytics.js",
      },
    ],
  }),
});

const queryClient = new QueryClient();

function RootComponent() {
  return (
    <QueryClientProvider client={queryClient}>
      <PhotoProvider>
        <React.Fragment>
          <Toaster />
          <HeadContent />
          <Outlet />
          {import.meta.env.MODE === "development" && <TanStackRouterDevtools />}
        </React.Fragment>
      </PhotoProvider>
    </QueryClientProvider>
  );
}

export default Route;
